export default __webpack_public_path__ + "static/media/Ugreen zone.9a9aaa7d.jpg";